/* eslint-disable react/no-array-index-key */
import React, {Fragment, Suspense, lazy} from "react";
import {Redirect, Route, Switch} from "react-router-dom";

import AuthGuard from "src/components/AuthGuard";
import GuestGuard from "src/components/GuestGuard";
import LoadingScreen from "src/components/LoadingScreen";
import DashboardLayout from "src/layouts/DashboardLayout";
import MainLayout from "src/layouts/MainLayout";
import HomeView from "src/views/pages/HomeView";

const routesConfig = [
  {
    exact: true,
    path: "/",
    component: () => <Redirect to="/login" />
  },
  {
    exact: true,
    path: "/404",
    component: lazy(() => import("src/views/pages/Error404View"))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: "/login",
    component: lazy(() => import("src/views/auth/LoginView"))
  },
  {
    exact: true,
    path: "/forgot-password",
    component: lazy(() => import("src/views/auth/ForgotPassword"))
  },
  {
    exact: true,
    path: "/reset-password",
    component: lazy(() => import("src/views/auth/ResetPassword"))
  },
  {
    exact: true,
    path: "/login-unprotected",
    component: lazy(() => import("src/views/auth/LoginView"))
  },
  {
    exact: true,
    guard: GuestGuard,
    path: "/register",
    component: lazy(() => import("src/views/auth/RegisterView"))
  },
  {
    exact: true,
    path: "/register-unprotected",
    component: lazy(() => import("src/views/auth/RegisterView"))
  },
  {
    path: "/app",
    guard: AuthGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: "/app",
        component: () => <Redirect to="/app/management/users" />
      },
      {
        exact: true,
        path: "/app/account",
        component: lazy(() => import("src/views/pages/AccountView"))
      },
      {
        exact: true,
        path: "/app/reports/dashboard",
        component: lazy(() => import("src/views/reports/DashboardView"))
      },
      {
        exact: true,
        path: "/app/reports/dashboard_new",
        component: lazy(() => import("src/views/reports/DashboardViewCustom"))
      },
      {
        exact: true,
        path: "/app/reports/announcement/create",
        component: lazy(() => import("src/views/reports/AnnouncementCreateView"))
      },
      {
        exact: true,
        path: "/app/reports/announcement/:id",
        component: lazy(() => import("src/views/reports/AnnouncementEditView"))
      },
      {
        exact: true,
        path: "/app/reports",
        component: () => <Redirect to="/app/reports/dashboard" />
      },
      {
        exact: true,
        path: "/app/management/customers",
        component: lazy(() => import("src/views/management/CustomerListView"))
      },
      {
        exact: true,
        path: "/app/management/customers/:customerId",
        component: lazy(() => import("src/views/management/CustomerDetailsView"))
      },
      {
        exact: true,
        path: "/app/management/customers/edit/:customerId",
        component: lazy(() => import("src/views/management/CustomerEditView"))
      },
      {
        exact: true,
        path: "/app/management/customer/create",
        component: lazy(() => import("src/views/management/CustomerCreateView"))
      },
      {
        exact: true,
        path: "/app/management/users",
        component: lazy(() => import("src/views/management/UserListView"))
      },
      {
        exact: true,
        path: "/app/management/users-customer",
        component: lazy(() => import("src/views/management/UserListView2"))
      },
      {
        exact: true,
        path: "/app/management/users/create",
        component: lazy(() => import("src/views/management/UserCreateView"))
      },
      // {
      //   exact: true,
      //   path: '/app/management/users/:id',
      //   component: lazy(() => import('src/views/management/UserDetailsView'))
      // },
      {
        exact: true,
        path: "/app/management/users/edit/:id",
        component: lazy(() => import("src/views/management/UserEditView"))
      },
      {
        exact: true,
        path: "/app/management/roles",
        component: lazy(() => import("src/views/management/RoleListView"))
      },
      {
        exact: true,
        path: "/app/management/roles/create",
        component: lazy(() => import("src/views/management/RoleCreateView"))
      },
      {
        exact: true,
        path: "/app/management/roles/edit/:id",
        component: lazy(() => import("src/views/management/RoleEditView"))
      },
      {
        exact: true,
        path: "/app/management/permissions",
        component: lazy(() => import("src/views/management/PermissionListView"))
      },
      {
        exact: true,
        path: "/app/management/permissions/create",
        component: lazy(() => import("src/views/management/PermissionCreateView"))
      },
      {
        exact: true,
        path: "/app/management/permissions/edit/:id",
        component: lazy(() => import("src/views/management/PermissionEditView"))
      },
      {
        exact: true,
        path: "/app/management/platform",
        component: lazy(() => import("src/views/management/PlatformListView"))
      },
      {
        exact: true,
        path: "/app/management/platform/create",
        component: lazy(() => import("src/views/management/PlatformCreateView"))
      },
      {
        exact: true,
        path: "/app/management/platform/:id",
        component: lazy(() => import("src/views/management/PlatformDetailsView"))
      },
      {
        exact: true,
        path: "/app/management/platform/edit/:id",
        component: lazy(() => import("src/views/management/PlatformEditView"))
      },
      // {
      //   exact: true,
      //   path: '/app/controlpanel/auditlog',
      //   component: lazy(() => import('src/views/controlpanel/AuditLogListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/controlpanel/auditlog/:id',
      //   component: lazy(() =>
      //     import('src/views/controlpanel/AuditLogDetailView')
      //   )
      // },
      {
        exact: true,
        path: "/app/management/languages",
        component: lazy(() => import("src/views/management/LanguageListView"))
      },
      {
        exact: true,
        path: "/app/management/languages/create",
        component: lazy(() => import("src/views/management/LanguageCreateView"))
      },
      {
        exact: true,
        path: "/app/management/languages/edit/:id",
        component: lazy(() => import("src/views/management/LanguageEditView"))
      },
      {
        exact: true,
        path: "/app/management/order",
        component: lazy(() => import("src/views/management/OrderListView"))
      },
      {
        exact: true,
        path: "/app/management/order-cashier",
        component: lazy(() => import("src/views/management/OrderListViewCashier"))
      },
      {
        exact: true,
        path: "/app/management/order-cashier/:id",
        component: lazy(() => import("src/views/management/OrderEditViewCashier"))
      },
      {
        exact: true,
        path: "/app/management/order/create",
        component: lazy(() => import("src/views/management/OrderCreateView"))
      },
      {
        exact: true,
        path: "/app/management/order/:orderId",
        component: lazy(() => import("src/views/management/OrderDetailsView"))
      },
      {
        exact: true,
        path: "/app/management/order/edit/:orderId",
        component: lazy(() => import("src/views/management/OrderEditView"))
      },
      {
        exact: true,
        path: "/app/management/picklist",
        component: lazy(() => import("src/views/management/PicklistView"))
      },
      {
        exact: true,
        path: "/app/management/hold-picklist",
        component: lazy(() => import("src/views/management/HoldPicklistView"))
      },
      {
        exact: true,
        path: "/app/management/approve-return-invoice",
        component: lazy(() => import("src/views/management/ApproveReturnInvoice"))
      },
      {
        exact: true,
        path: "/app/management/request-list",
        component: lazy(() => import("src/views/management/WaybillView"))
      },
      {
        exact: true,
        path: "/app/management/waybill-list",
        component: lazy(() => import("src/views/management/DistributeOrderView"))
      },
      {
        exact: true,
        path: "/app/management",
        component: () => <Redirect to="/app/management/users" />
      },
      {
        exact: true,
        path: "/app/management/booking-engine",
        component: lazy(() => import("src/views/management/BookingEngine"))
      },
      {
        exact: true,
        path: "/app/masterdata/address",
        component: lazy(() => import("src/views/masterdata/AddressListView"))
      },
      {
        exact: true,
        path: "/app/masterdata",
        component: () => <Redirect to="/app/masterdata/address" />
      },
      {
        exact: true,
        path: "/app/management/station",
        component: lazy(() => import("src/views/management/StationListView"))
      },
      {
        exact: true,
        path: "/app/management/station/create",
        component: lazy(() => import("src/views/management/StationCreateView"))
      },
      {
        exact: true,
        path: "/app/management/station/edit/:id",
        component: lazy(() => import("src/views/management/StationEditView"))
      },
      {
        exact: true,
        path: "/app/management/report",
        component: lazy(() => import("src/views/management/OperationDashboard"))
      },
      {
        exact: true,
        path: "/app/management/stocks",
        component: lazy(() => import("src/views/management/StockListView"))
      },
      {
        exact: true,
        path: "/app/management/stocks/edit/:stockId",
        component: lazy(() => import("src/views/management/StockFormView"))
      },
      {
        exact: true,
        path: "/app/management/stocks/create",
        component: lazy(() => import("src/views/management/StockFormView"))
      },
      // {
      //   exact: true,
      //   path: '/app/management/stocks-fulfillment',
      //   component: lazy(() => import('src/views/management/StockFulfillmentListView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/stocks-fulfillment/edit/:stockId',
      //   component: lazy(() => import('src/views/management/StockFormFulfillmentView'))
      // },
      // {
      //   exact: true,
      //   path: '/app/management/stocks-fulfillment/create',
      //   component: lazy(() => import('src/views/management/StockFormFulfillmentView'))
      // },
      {
        exact: true,
        path: "/app/management/report-stocks",
        component: lazy(() => import("src/views/management/ReportStockListView"))
      },
      {
        exact: true,
        path: "/app/management/time-slot-capacity/create",
        component: lazy(() => import("src/views/management/CapacityTimeSlotFormView"))
      },
      {
        exact: true,
        path: "/app/management/time-slot-capacity/edit/:slotId",
        component: lazy(() => import("src/views/management/CapacityTimeSlotFormView"))
      },
      {
        exact: true,
        path: "/app/management/time-slot-capacity",
        component: lazy(() => import("src/views/management/CapacityTimeSlotView"))
      },
      {
        exact: true,
        path: "/app/management/language-setting",
        component: lazy(() => import("src/views/management/LanguageSettingListView"))
      },
      {
        exact: true,
        path: "/app/management/language-setting/create",
        component: lazy(() => import("src/views/management/LanguageSettingCreateView"))
      },
      {
        exact: true,
        path: "/app/management/language-setting/edit/:key",
        component: lazy(() => import("src/views/management/LanguageSettingEditView"))
      },
      {
        exact: true,
        path: "/app/management/reasons",
        component: lazy(() => import("src/views/management/ReasonListView"))
      },
      {
        exact: true,
        path: "/app/management/customer-fee",
        component: lazy(() => import("src/views/management/CustomerFeeView"))
      },
      {
        exact: true,
        path: "/app/management/customer-fee/create",
        component: lazy(() => import("src/views/management/CustomerFeeFormView"))
      },
      {
        exact: true,
        path: "/app/management/customer-fee/edit/:feeId",
        component: lazy(() => import("src/views/management/CustomerFeeFormView"))
      },
      {
        exact: true,
        path: "/app/management/shipping-type",
        component: lazy(() => import("src/views/management/ShippingTypeView"))
      },
      {
        exact: true,
        path: "/app/management/shipping-type/create",
        component: lazy(() => import("src/views/management/ShippingTypeCreateView"))
      },
      {
        exact: true,
        path: "/app/management/shipping-type/edit/:id",
        component: lazy(() => import("src/views/management/ShippingTypeEditView"))
      },
      {
        exact: true,
        path: "/app/management/supplier",
        component: lazy(() => import("src/views/management/SupplierListView"))
      },
      {
        exact: true,
        path: "/app/management/supplier/create",
        component: lazy(() => import("src/views/management/SupplierCreateView"))
      },
      {
        exact: true,
        path: "/app/management/codReport",
        component: lazy(() => import("src/views/management/CODReport"))
      },
      {
        exact: true,
        path: "/app/management/supplier/edit/:id",
        component: lazy(() => import("src/views/management/SupplierEditView"))
      },
      {
        exact: true,
        path: "/app/management/supplier/:id",
        component: lazy(() => import("src/views/management/SupplierDetailsView"))
      },
      {
        exact: true,
        path: "/app/management/supplier/clone/:id",
        component: lazy(() => import("src/views/management/SupplierCloneView"))
      },
      {
        exact: true,
        path: "/app/content/category-management",
        component: lazy(() => import("src/views/content/Category/CategoryManagement"))
      },
      {
        exact: true,
        path: "/app/content/category-management/create",
        component: lazy(() =>
          import("src/views/content/Category/CategoryManagement/CategoryCreateView")
        )
      },
      {
        exact: true,
        path: "/app/content/category-management/edit/:id/:parentId?",
        component: lazy(() =>
          import("src/views/content/Category/CategoryManagement/CategoryEditView")
        )
      },
      {
        exact: true,
        path: "/app/content/category-management/detail/:id/:parentId?",
        component: lazy(() =>
          import("src/views/content/Category/CategoryManagement/CategoryDetailView")
        )
      },
      {
        exact: false,
        path: "/app/content/comments",
        component: lazy(() => import("src/views/content/CommentListView"))
      },
      {
        exact: true,
        path: "/app/content/comments/edit/:id",
        component: lazy(() => import("src/views/content/CommentEditView"))
      },
      {
        exact: true,
        path: "/app/content/review",
        component: lazy(() => import("src/views/content/ReviewListView"))
      },
      {
        exact: true,
        path: "/app/content/review/edit/:id",
        component: lazy(() => import("src/views/content/ReviewEditView"))
      },
      {
        exact: true,
        path: "/app/content/variants",
        component: lazy(() => import("src/views/content/VariantListView"))
      },
      {
        exact: true,
        path: "/app/content/item-attributes",
        component: lazy(() => import("src/views/content/ItemAttributeListView"))
      },
      {
        exact: true,
        path: "/app/content/product-management",
        component: lazy(() => import("src/views/content/ProductManagementListView"))
      },
      {
        exact: true,
        path: "/app/content/product-management/edit/:productId",
        component: lazy(() => import("src/views/content/ProductFormView"))
      },
      {
        exact: true,
        path: "/app/content/product-management/detail/:productId",
        component: lazy(() => import("src/views/content/ProductViewDetail"))
      },
      {
        exact: true,
        path: "/app/content/product-management/create",
        component: lazy(() => import("src/views/content/ProductFormView"))
      },
      {
        exact: true,
        path: "/app/content/media",
        component: lazy(() => import("src/views/content/MediaListView"))
      },
      {
        exact: true,
        path: "/app/content/media/create",
        component: lazy(() => import("src/views/content/MediaCreateView"))
      },
      {
        exact: true,
        path: "/app/content/media/edit/:id",
        component: lazy(() => import("src/views/content/MediaEditView"))
      },
      {
        exact: true,
        path: "/app/content/brand",
        component: lazy(() => import("src/views/content/BrandListView"))
      },
      {
        exact: true,
        path: "/app/content/brand/create",
        component: lazy(() => import("src/views/content/BrandFormView"))
      },
      {
        exact: true,
        path: "/app/content/brand/edit/:brandId",
        component: lazy(() => import("src/views/content/BrandFormView"))
      },
      {
        exact: true,
        path: "/app/content/seller",
        component: lazy(() => import("src/views/content/SellerListView"))
      },
      {
        exact: true,
        path: "/app/content/seller/edit/:sellerId",
        component: lazy(() => import("src/views/content/SellerEditView"))
      },
      {
        exact: true,
        path: "/app/masterdata/policy",
        component: lazy(() => import("src/views/masterdata/PolicyListView"))
      },
      {
        exact: true,
        path: "/app/management/bagging",
        component: lazy(() => import("src/views/management/PicklistSearchView"))
      },
      {
        exact: true,
        path: "/app/management/campaign-price",
        component: lazy(() => import("src/views/management/CampaignPriceListView"))
      },
      {
        exact: true,
        path: "/app/management/campaign-price/create",
        component: lazy(() => import("src/views/management/CampaignPriceCreateView"))
      },
      {
        exact: true,
        path: "/app/management/campaign-price/edit/:id",
        component: lazy(() => import("src/views/management/CampaignPriceEditView"))
      },
      // {
      //   exact: true,
      //   path: '/app/management/package/search',
      //   component: lazy(() => import('src/views/management/PackageSearchView'))
      // },
      {
        exact: true,
        path: "/app/management/promotion",
        component: lazy(() => import("src/views/management/PromotionListView"))
      },
      {
        exact: true,
        path: "/app/management/promotion/create",
        component: lazy(() => import("src/views/management/PromotionCreateView"))
      },
      {
        exact: true,
        path: "/app/management/promotion/edit/:id",
        component: lazy(() => import("src/views/management/PromotionEditView"))
      },
      {
        exact: true,
        path: "/app/management/private-coupon",
        component: lazy(() => import("src/views/management/PrivateCouponView"))
      },
      {
        exact: true,
        path: "/app/management/private-coupon/create",
        component: lazy(() => import("src/views/management/PrivateCouponFormView"))
      },
      {
        exact: true,
        path: "/app/management/private-coupon/edit/:id",
        component: lazy(() => import("src/views/management/PrivateCouponFormView"))
      },
      {
        exact: true,
        path: "/app/management/setting-coupon",
        component: lazy(() => import("src/views/management/CouponView"))
      },
      {
        exact: true,
        path: "/app/management/order-process",
        component: lazy(() => import("src/views/management/OrderProcessListView"))
      },
      {
        exact: true,
        path: "/app/management/mass-upload",
        component: lazy(() => import("src/views/management/MassUploadView"))
      },
      {
        exact: true,
        path: "/app/management/pricing",
        component: lazy(() => import("src/views/management/PricingListView"))
      },
      {
        exact: true,
        path: "/app/management/notification/rules",
        component: lazy(() => import("src/views/management/NotificationListView"))
      },
      {
        exact: true,
        path: "/app/management/shipper-inhouse",
        component: lazy(() => import("src/views/management/ShipperInHouseListView"))
      },
      {
        exact: true,
        path: "/app/management/shipper-inhouse/create",
        component: lazy(() => import("src/views/management/ShipperInHouseCreateView"))
      },
      {
        exact: true,
        path: "/app/management/shipper-inhouse/edit/:id",
        component: lazy(() => import("src/views/management/ShipperInHouseEditView"))
      },
      {
        exact: true,
        path: "/app/management/notification/rules/edit/:id",
        component: lazy(() => import("src/views/management/notificationDetailView"))
      },
      {
        exact: true,
        path: "/app/management/notification/rules/create",
        component: lazy(() => import("src/views/management/notificationCreateView"))
      },
      {
        exact: true,
        path: "/app/management/notification/rules/clone/:id",
        component: lazy(() => import("src/views/management/NotificationCloneView"))
      },
      {
        exact: true,
        path: "/app/management/notification/massive/create",
        component: lazy(() => import("src/views/management/notificationMassiveFormView"))
      },
      {
        exact: true,
        path: "/app/management/notification/massive/edit/:id",
        component: lazy(() => import("src/views/management/notificationMassiveFormView"))
      },
      {
        exact: true,
        path: "/app/management/notification/massive/clone/:id",
        component: lazy(() => import("src/views/management/notificationMassiveFormView"))
      },
      {
        exact: true,
        path: "/app/management/notification/massive",
        component: lazy(() => import("src/views/management/NotificationListView"))
      },
      {
        exact: true,
        path: "/app/management/notification/massive-history",
        component: lazy(() => import("src/views/management/NotificationListView"))
      },
      {
        exact: true,
        path: "/app/management/order-verification",
        component: lazy(() => import("src/views/management/OrderVerificationListView"))
      },
      {
        exact: true,
        path: "/app/management/ticket",
        component: lazy(() => import("src/views/management/TicketListView"))
      },
      {
        exact: true,
        path: "/app/management/refund-transaction",
        component: lazy(() => import("src/views/management/RefundTransactionListView"))
      },
      {
        exact: true,
        path: "/app/management/return-package",
        component: lazy(() => import("src/views/management/ReturnPackageListView"))
      },
      {
        exact: true,
        path: "/app/masterdata/metadata",
        component: lazy(() => import("src/views/masterdata/MetadataListView"))
      },
      {
        exact: true,
        path: "/app/masterdata/metadata/create",
        component: lazy(() => import("src/views/masterdata/MetadataCreateView"))
      },
      {
        exact: true,
        path: "/app/masterdata/metadata/edit/:id",
        component: lazy(() => import("src/views/masterdata/MetadataEditView"))
      },
      {
        exact: true,
        path: "/app/masterdata/tag",
        component: lazy(() => import("src/views/management/TagListView"))
      },
      {
        exact: true,
        path: "/app/masterdata/tag/create",
        component: lazy(() => import("src/views/management/TagFormView"))
      },
      {
        exact: true,
        path: "/app/masterdata/tag/edit/:tagId",
        component: lazy(() => import("src/views/management/TagFormView"))
      },
      {
        exact: true,
        path: "/app/masterdata/cms",
        component: lazy(() => import("src/views/cms"))
      },
      {
        exact: true,
        path: "/app/content",
        component: () => <Redirect to="/app/content/product-management" />
      },
      {
        exact: true,
        path: "/app/management/notification",
        component: () => <Redirect to="/app/management/notification/rules" />
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: "*",
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: "/login",
        component: HomeView
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
];

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, i) => {
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Component = route.component;

          return (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {route.routes ? renderRoutes(route.routes) : <Component {...props} />}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense>
  ) : null;

function Routes() {
  return renderRoutes(routesConfig);
}

export default Routes;
